module.exports = __webpack_public_path__ + "img/bosspack_dfod_k.e00c378d.png";